import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared-components/shared.module';

import { IncoOplreportingComponent } from './inco-oplreporting.component';

@NgModule({
  declarations: [
    IncoOplreportingComponent
  ],
  imports: [CommonModule, SharedModule],
  exports: [IncoOplreportingComponent]
})
export class IncoOplReportingModule {}
